import styled from 'styled-components'
import { colors } from '../../theme'

export const Container = styled.div`
  padding: 0 10px;
`

export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  margin-top: 28px;
  margin-bottom: 20px;
`

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  /* Filho DIRETO de proposito: este rotulo e o <span> do proprio campo.
     Um 'span' solto tambem casaria com o <span> interno que o Select do
     Ant Design usa para exibir o valor escolhido — e o valor sairia com a
     cor do rotulo, mais apagada que o resto do texto. */

  > span {
    font-family: 'Poppins';
    font-size: 12px;
    color: ${colors.grey600};
  }
`

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
`

export const MetricCard = styled.div`
  background: ${colors.surface};
  border-radius: 12px;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const MetricTitle = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: 'Poppins';
  font-size: 13px;
  color: ${colors.grey600};
`

// Badge circular de legenda (ex.: "?") ancorado a um antd Tooltip. Sem @ant-design/icons.
export const LegendIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid ${colors.grey500};
  color: ${colors.grey500};
  font-family: 'Poppins';
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  cursor: help;
  flex-shrink: 0;
  vertical-align: middle;
`

export const MetricValue = styled.strong`
  font-family: 'Poppins';
  font-size: 28px;
  color: ${colors.primaryText};
`

export const MetricHint = styled.span`
  font-family: 'Poppins';
  font-size: 12px;
  color: ${colors.grey900};
`

// PD-0006 - o número vira o gatilho do drill. É o VALOR que é clicável, não o card inteiro:
// o card contém o badge de legenda (com tabIndex próprio), e aninhar um elemento focável
// dentro de um botão quebra a navegação por teclado.
export const MetricValueBotao = styled.button`
  align-self: flex-start;
  padding: 0;
  border: none;
  background: none;
  font-family: 'Poppins';
  font-size: 28px;
  font-weight: 700;
  color: ${colors.primaryText};
  cursor: pointer;
  text-decoration: underline dotted ${colors.grey500};
  text-underline-offset: 5px;

  &:hover,
  &:focus-visible {
    text-decoration: underline solid ${colors.primaryText};
  }
`

// Sub-número dentro do card (Trabalhadas / Base): mesma affordance, tamanho da MetricHint.
export const HintBotao = styled.button`
  padding: 0;
  border: none;
  background: none;
  font-family: 'Poppins';
  font-size: 12px;
  font-weight: 600;
  color: ${colors.primaryText};
  cursor: pointer;
  text-decoration: underline dotted ${colors.grey500};
  text-underline-offset: 3px;

  &:hover,
  &:focus-visible {
    text-decoration: underline solid ${colors.primaryText};
  }
`

export const ContadorBotao = styled.button`
  padding: 0;
  border: none;
  background: none;
  font-family: 'Poppins';
  font-size: 13px;
  font-weight: 700;
  color: ${colors.primaryText};
  cursor: pointer;
  text-decoration: underline dotted ${colors.grey500};
  text-underline-offset: 4px;

  &:hover,
  &:focus-visible {
    text-decoration: underline solid ${colors.primaryText};
  }
`

export const CountersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-bottom: 24px;

  span {
    font-family: 'Poppins';
    font-size: 13px;
    color: ${colors.grey900};
    /* Cada contador quebra INTEIRO para a linha de baixo: sem isto, em tela
       estreita o rótulo se separava do valor e do ícone de ajuda. */
    white-space: nowrap;
  }

  strong {
    color: ${colors.primaryText};
  }
`

export const SectionTitle = styled.h2`
  font-family: 'Poppins';
  font-size: 18px;
  color: ${colors.primaryText};
  margin: 24px 0 12px;
`

export const ChartWrapper = styled.div`
  background: ${colors.surface};
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
`

export const RankingsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 20px;
`

export const TableWrapper = styled.div`
  background: ${colors.surface};
  border-radius: 12px;
  padding: 16px;
  overflow-x: auto;
`

// ===== PD-0006 - painel lateral do drill-down =====

export const DrillCabecalho = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;
`

// A conta que originou o quadro ("41 ÷ 149 = 27,5%"). É o que transforma o painel em prova
// da divisão, e não em duas listas soltas.
export const DrillConta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-family: 'Poppins';
  font-size: 13px;
  color: ${colors.grey900};
`

export const DrillLado = styled.button<{ ativo: boolean }>`
  padding: 5px 10px;
  border: 1px solid
    ${props => (props.ativo ? colors.secondary : colors.grey500)};
  border-radius: 8px;
  background: ${props => (props.ativo ? colors.accentBg : colors.surfaceHigh)};
  color: ${props => (props.ativo ? colors.white : colors.grey900)};
  font-family: 'Poppins';
  font-size: 12px;
  cursor: pointer;
`

export const DrillDefinicao = styled.p`
  margin: 0;
  font-family: 'Poppins';
  font-size: 12px;
  color: ${colors.grey900};
  line-height: 1.5;
`

// Recorte aplicado + o aviso de que o período corta pela data de CRIAÇÃO do episódio.
// Sem esse aviso o usuário compara com a tela de Vendas e conclui que há erro.
export const DrillRecorte = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  padding: 10px 12px;
  border-radius: 8px;
  background: ${colors.grey100};
  font-family: 'Poppins';
  font-size: 11px;
  color: ${colors.grey600};
  line-height: 1.5;
`

export const DrillBarra = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`

export const DrillContagem = styled.span`
  font-family: 'Poppins';
  font-size: 12px;
  color: ${colors.grey600};
`

export const DrillBotaoExportar = styled.button`
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  background: ${colors.accentBg};
  color: ${colors.white};
  font-family: 'Poppins';
  font-size: 12px;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`

// Cabeçalho de coluna ordenável. Botão de verdade (e não th com onClick) para a ordenação
// ser alcançável por teclado sem regra de a11y desligada.
export const DrillOrdenar = styled.button<{ ativo: boolean }>`
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  color: inherit;
  cursor: pointer;
  text-decoration: ${props => (props.ativo ? 'underline' : 'none')};
`

export const DrillVazio = styled.div`
  padding: 24px 4px;
  font-family: 'Poppins';
  font-size: 13px;
  color: ${colors.grey900};
  line-height: 1.6;
`

// Ausência do detalhe da venda é informação, não lacuna: a venda ocorreu (a data ao lado é
// congelada), mas venda_item foi recriada por uma reimportação.
export const DrillIndisponivel = styled.span`
  font-family: 'Poppins';
  font-size: 11px;
  font-style: italic;
  color: ${colors.grey600};
`

export const DrillLink = styled.a`
  color: ${colors.primaryText};
  text-decoration: underline;
`
